<!-- 视频播放器 支持flv流,mp4文件，原生初版 功能单一，只做播放展示用-->
<template>
    <div class="player-box" :style="{ background: isFirefox ? '#000' : 'transparent', position: 'relative' }">
        <div v-show="isLoading"
            :style="`background-image: url(${poster}); background-size: cover; width: 100%; height: 100%; position: absolute;left:0;top:0`">

        </div>
        <video controls id="videoDom" class="player-box" :style="{ background: isFirefox ? '#000' : '' }"></video>
    </div>

</template>

<script>

import { isFirefoxBrowser } from '@/utils/index';
import PmStreaming from "../streaming/src";
import FlvPlayer from "xgplayer-flv";
import HlsPlugin from "xgplayer-hls";


export default {
    name: 'videoPlayer',
    props: {
        width: { type: String },
        height: { type: String },
        videoUrl: { type: String },
        controls: {
            type: Boolean,
            default: true
        },
        limitReloadCount: {
            type: Number,
            default: 10,
        },
        poster: {
            type: String,
            default: require('@/assets/img/bigScreen/defaultVideoBg.png')
        },
        videoCode: {
            type: String,
            default: "mp4", //只支持mp4或MP4
            validator: function (value) {
                // 这个值必须匹配下列字符串中的一个
                return ["flv", "MP4"].indexOf(value) !== -1;
            },
        },
        voice: {
            type: Boolean,
            default: true,
        },
        id: {
            type: String,
            default: '1'
        },
        serverUrl: {
            type: String,
            default: ''
        },
        isLive: {
            type: Boolean,
            default: true,
        }
    },
    watch: {
        videoUrl: {
            handler() {
                this.reloadUrl(true);
            },
            deep: true,
        },
    },
    data() {
        return {
            isLoading: false,
            isFirefox: false,
            videoPlayerDom: null,
        }
    },
    created() {
        this.isFirefox = isFirefoxBrowser()
    },
    mounted() {
        this.initVideo();
    },
    methods: {
        // 视频截图及上传文件服务器
        cutVideoScreen(){
            debugger
            var fileType = "png";  // 如果文件名中没有带后缀，默认使用png
            var video = document.getElementById('videoDom');  // 找到需要截图的video标签
            console.log(video, 'aaa')
            if(video){
                var canvas = window.canvas = document.createElement("canvas");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);  // 图片大小和视频分辨率一致
                var strDataURL = canvas.toDataURL("image/" + fileType);   // canvas中video中取一帧图片并转成dataURL
                console.log(strDataURL)
                var arr = strDataURL.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var blob = new Blob([u8arr], {
                    type: mime
                });

                const formData = new FormData();
                formData.append('file', blob);

                if(blob){

                    this.$http.post('/bigfileUpload/uploadFile',formData ).then(res => {


                        if(res.data.code == "1"){
                            var filePath = res.data.data;
                            this.$emit('cutAndUploadSuccess', filePath);

                        }else{
                            this.$message({message: "上传失败", type: "error"});
                        }

                    }).catch(e => {

                    })

                }
            }

        },
        reloadUrl(sourceChange) {
            if (sourceChange && this.videoPlayerDom) {
                this.videoPlayerDom.flvPlayer.destroy();
                this.videoPlayerDom = null;
            }
            this.initVideo();
        },
        play() { //播放
            if (this.videoPlayerDom) {
                this.videoPlayerDom.flvPlayer.load(); //加载
                this.videoPlayerDom.flvPlayer.play();
            }
        },
        pause() { // 暂停
            if (this.videoPlayerDom) {
                this.videoPlayerDom.flvPlayer.pause();
            }
        },
        initVideo() {
            let videoUrl = this.videoUrl
            let isLive = this.isLive  //控制是否直播
            if (!isLive) {

            }
            let plugins = [];
            this.isLoading = true;
            if (!videoUrl) {
                return
            }
            this.isLoading = false;

            if (videoUrl.indexOf('.flv') != -1) {
                plugins = [FlvPlayer]
            } else {
                plugins = [HlsPlugin]
            }


            this.videoPlayerDom = new PmMonitoringSdk.FlvPlus({
                el: document.getElementById(`videoDom`),
                media: {
                    type: videoUrl.indexOf('.flv') != -1 ? 'flv' : 'm3u8',
                    url: videoUrl,
                    hasAudio:true,
                },

                config: {
                    width: '100%',
                    height: '100%',
                    plugins,
                },
                volume: 1,
                time: 1,
                closeVideoClick: true,
            })
            // 新的播放器js 再构建完成之后要init一下
            this.videoPlayerDom.init();

            // 播放器配置项
            // this.videoPlayerDom = new PmStreaming({
            //     url: videoUrl,
            //     el: document.getElementById(`videoDom`),
            //     pageTurning: false,
            //     volume: 1,
            //     isLive:isLive, 
            //     width: '100%',
            //     height: '100%',
            //     commonStyle: {
            //         volumeColor: 'green'
            //     },
            //     screenShot: {
            //         disable: false
            //     },
            //     plugins
            // })

            this.videoPlayerDom.flvPlayer.on('screenShot', (url) => {
                var blob = new Blob([url], {
                    type: 'image/png'
                });

                const formData = new FormData();
                formData.append('file', blob);
                if (blob) {
                    this.$http.post('/bigfileUpload/uploadFile', formData).then(res => {
                        if (res.data.code == "1") {
                            var filePath = res.data.data;
                            this.$emit('cutAndUploadSuccess', filePath);
                        } else {
                            this.$message({ message: "上传失败", type: "error" });
                        }
                    })
                }
            })
        },
    },



    destroyed() {
        if (this.videoPlayerDom) {
            this.videoPlayerDom.flvPlayer.destroy();
        }
    },
}
</script>

<style lang="less" scoped>
.player-box {
    position: relative;
    width: 100%;
    height: 100%;

    .video-body {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }

    .loader {
        width: 140px;
        height: 140px;
        text-align: center;
        position: absolute;
        top: calc(50% - 40px);
        left: calc(50% - 70px);
        padding-top: 15px;
        z-index: 900;
        border-radius: 5px;

        .loader-1 {
            width: 60px;
            height: 60px;

        }

        svg path,
        svg rect {
            fill: #17a085;
        }
    }

    .load-msg {
        height: 50px;
        line-height: 50px;
        color: #fff;
        font-size: 13px;
        margin-top: 20px;
    }
}
</style>